(function () {
  'use strict';

  var LIST_SELECTOR = '.npt__features, .mt-product__features';
  var resizeTimer;
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotionQuery.matches;
  }

  function debounce(fn, ms) {
    return function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fn, ms);
    };
  }

  function ensureShell(list) {
    var parent = list.parentElement;
    if (
      parent &&
      (parent.classList.contains('npt__features-shell') ||
        parent.classList.contains('mt-product__features-shell'))
    ) {
      return parent;
    }

    var shell = document.createElement('div');
    shell.className = list.classList.contains('npt__features')
      ? 'npt__features-shell'
      : 'mt-product__features-shell';
    list.parentNode.insertBefore(shell, list);
    shell.appendChild(list);
    return shell;
  }

  function destroyController(shell) {
    if (shell && shell._sellingPointsMarquee) {
      shell._sellingPointsMarquee.destroy();
      shell._sellingPointsMarquee = null;
    }
  }

  function readTranslateX(element) {
    var transform = window.getComputedStyle(element).transform;
    if (!transform || transform === 'none') return 0;
    try {
      return new DOMMatrixReadOnly(transform).m41;
    } catch (e) {
      return 0;
    }
  }

  function SellingPointsMarquee(shell, list, loopDistance) {
    this.shell = shell;
    this.list = list;
    this.loopDistance = loopDistance;
    this.mode = 'auto';
    this.userActive = false;
    this.resumeTimer = null;
    this.dragging = false;
    this.startX = 0;
    this.startScroll = 0;
    this.pointerId = null;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);

    shell.addEventListener('pointerdown', this.onPointerDown);
    shell.addEventListener('pointermove', this.onPointerMove);
    shell.addEventListener('pointerup', this.onPointerUp);
    shell.addEventListener('pointercancel', this.onPointerUp);
    shell.addEventListener('scroll', this.onScroll, { passive: true });
    shell.addEventListener('touchstart', this.onTouchStart, { passive: true });
    shell.addEventListener(
      'wheel',
      function (event) {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
          this.enterManual();
          this.pauseAuto(4500);
        }
      }.bind(this),
      { passive: true }
    );

    this.enterAuto();
  }

  SellingPointsMarquee.prototype.normalizeScroll = function () {
    if (this.loopDistance <= 0) return;
    while (this.shell.scrollLeft >= this.loopDistance) {
      this.shell.scrollLeft -= this.loopDistance;
    }
    while (this.shell.scrollLeft < 0) {
      this.shell.scrollLeft += this.loopDistance;
    }
  };

  SellingPointsMarquee.prototype.onScroll = function () {
    if (this.mode !== 'manual') return;
    this.normalizeScroll();
    this.pauseAuto(4500);
  };

  SellingPointsMarquee.prototype.enterAuto = function () {
    this.mode = 'auto';
    this.shell.classList.remove('is-manual');
    this.shell.classList.remove('is-dragging');
    this.shell.scrollLeft = 0;
    this.list.style.transform = '';
    this.list.classList.remove('is-marquee-manual');
    if (prefersReducedMotion()) {
      this.list.classList.remove('is-marquee-auto');
      this.enterManual();
      return;
    }
    this.list.classList.add('is-marquee-auto');
  };

  SellingPointsMarquee.prototype.enterManual = function () {
    if (this.mode === 'manual') return;

    var offset = Math.abs(readTranslateX(this.list));
    this.mode = 'manual';
    this.list.classList.remove('is-marquee-auto');
    this.list.classList.add('is-marquee-manual');
    this.list.style.transform = 'none';
    this.shell.classList.add('is-manual');
    this.shell.scrollLeft = Math.min(offset, this.loopDistance);
    this.normalizeScroll();
  };

  SellingPointsMarquee.prototype.pauseAuto = function (ms) {
    this.userActive = true;
    clearTimeout(this.resumeTimer);
    this.resumeTimer = setTimeout(
      function () {
        this.userActive = false;
        this.enterAuto();
      }.bind(this),
      ms == null ? 3200 : ms
    );
  };

  SellingPointsMarquee.prototype.onTouchStart = function () {
    this.enterManual();
    this.pauseAuto(5500);
  };

  SellingPointsMarquee.prototype.onPointerDown = function (event) {
    if (event.pointerType === 'touch') {
      this.enterManual();
      this.pauseAuto(5500);
      return;
    }
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    this.enterManual();
    this.dragging = true;
    this.userActive = true;
    this.startX = event.clientX;
    this.startScroll = this.shell.scrollLeft;
    this.pointerId = event.pointerId;
    this.shell.classList.add('is-dragging');
    clearTimeout(this.resumeTimer);
    try {
      this.shell.setPointerCapture(event.pointerId);
    } catch (e) {}
  };

  SellingPointsMarquee.prototype.onPointerMove = function (event) {
    if (!this.dragging || event.pointerId !== this.pointerId) return;
    this.shell.scrollLeft = this.startScroll - (event.clientX - this.startX);
    this.normalizeScroll();
  };

  SellingPointsMarquee.prototype.onPointerUp = function (event) {
    if (event.pointerId !== this.pointerId) return;
    this.dragging = false;
    this.pointerId = null;
    this.shell.classList.remove('is-dragging');
    try {
      this.shell.releasePointerCapture(event.pointerId);
    } catch (e) {}
    this.normalizeScroll();
    this.pauseAuto(3200);
  };

  SellingPointsMarquee.prototype.destroy = function () {
    clearTimeout(this.resumeTimer);
    this.shell.classList.remove('is-manual', 'is-dragging', 'is-marquee');
    this.list.classList.remove('is-marquee-auto', 'is-marquee-manual', 'is-marquee');
    this.list.style.transform = '';
    this.shell.removeEventListener('pointerdown', this.onPointerDown);
    this.shell.removeEventListener('pointermove', this.onPointerMove);
    this.shell.removeEventListener('pointerup', this.onPointerUp);
    this.shell.removeEventListener('pointercancel', this.onPointerUp);
    this.shell.removeEventListener('scroll', this.onScroll);
    this.shell.removeEventListener('touchstart', this.onTouchStart);
    this.shell.scrollLeft = 0;
  };

  function resetList(list, shell) {
    destroyController(shell);
    list.querySelectorAll('[data-marquee-clone]').forEach(function (node) {
      node.remove();
    });
    list.classList.remove('is-marquee', 'is-marquee-auto', 'is-marquee-manual', 'is-fit');
    shell.classList.remove('is-marquee', 'is-manual', 'is-dragging');
    list.style.removeProperty('--npt-marquee-distance');
    list.style.removeProperty('--npt-marquee-duration');
    list.style.transform = '';
    shell.scrollLeft = 0;
  }

  function setupList(list) {
    if (!list) return;

    var shell = ensureShell(list);
    resetList(list, shell);

    var items = Array.from(list.children).filter(function (child) {
      return !child.hasAttribute('data-marquee-clone');
    });
    if (!items.length) return;

    list.classList.add('is-fit');
    void list.offsetWidth;

    if (list.scrollWidth <= shell.clientWidth + 1) {
      return;
    }

    list.classList.remove('is-fit');
    list.classList.add('is-marquee');
    shell.classList.add('is-marquee');

    var loopDistance = list.scrollWidth;
    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('data-marquee-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      list.appendChild(clone);
    });

    list.style.setProperty('--npt-marquee-distance', loopDistance + 'px');
    list.style.setProperty(
      '--npt-marquee-duration',
      Math.max(14, Math.round(loopDistance / 32)) + 's'
    );

    shell._sellingPointsMarquee = new SellingPointsMarquee(shell, list, loopDistance);
  }

  function setupAll(root) {
    root.querySelectorAll(LIST_SELECTOR).forEach(function (list) {
      var panel = list.closest('[data-npt-panel]');
      if (panel && panel.hasAttribute('hidden')) return;
      setupList(list);
    });
  }

  function init() {
    setupAll(document);
    window.addEventListener('resize', debounce(function () {
      setupAll(document);
    }, 150));
    window.addEventListener('load', function () {
      setupAll(document);
    });
    document.addEventListener('npt:product:change', function () {
      requestAnimationFrame(function () {
        setupAll(document);
      });
    });
    document.addEventListener('shopify:section:load', function () {
      requestAnimationFrame(function () {
        setupAll(document);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
